var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-class"},[_c('p',[_c('span',{staticClass:"title"},[_vm._v("课程所属班级:")]),_c('span',{staticClass:"title name",on:{"click":function($event){return _vm.$router.push({
          name: 'ClassesDetail',
          params: { id: _vm.course.class_id },
        })}}},[_vm._v("\n      "+_vm._s(_vm.course.class_name)+"\n    ")]),_c('img',{staticStyle:{"width":"5px"},attrs:{"src":require("@/assets/images/course/class-course-right.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }